import { CheckboxGroup as ChakraCheckboxGroup, CheckboxGroupProps as ChakraCheckboxGroupProps } from '@chakra-ui/react';
import Box, { BoxProps } from '../../Box/Box';

export type CheckboxGroupProps = Omit<ChakraCheckboxGroupProps, 'onChange'> &
  Omit<BoxProps, 'onChange'> & {
    onChange?(value: Array<string>): void;
  };

/**
 * CheckboxGroup component to help manage the checked state of its children Checkbox components and conveniently pass a few shared style props to each.
 * Composes Box.
 */
const CheckboxGroup = (props: CheckboxGroupProps) => {
  const { children, defaultValue, isDisabled, isNative, onChange, value, ...boxProps } = props;
  const groupProps = {
    defaultValue,
    isDisabled,
    isNative,
    onChange,
    value,
  };
  return (
    <ChakraCheckboxGroup {...groupProps}>
      <Box {...boxProps}>{children}</Box>
    </ChakraCheckboxGroup>
  );
};

export default CheckboxGroup;
